var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyRefer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 52,
    height: 49,
    rx: 3.5,
    fill: "#F7F7FC",
    stroke: "#D9DBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4299 21.8844C33.904 21.8844 33.2074 21.8728 32.3402 21.8728C30.2252 21.8728 28.4861 20.1222 28.4861 17.9873V14.2416C28.4861 13.947 28.2508 13.707 27.959 13.707H21.7984C18.9234 13.707 16.5996 16.0667 16.5996 18.9587V31.5084C16.5996 34.5425 19.0341 37.0012 22.0383 37.0012H31.2123C34.077 37.0012 36.3996 34.6566 36.3996 31.7623V22.4086C36.3996 22.1127 36.1655 21.874 35.8726 21.8751C35.3801 21.8786 34.7897 21.8844 34.4299 21.8844Z",
    fill: "#03A438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.256 14.367C30.9078 14.0048 30.2998 14.2541 30.2998 14.7561V17.8274C30.2998 19.1156 31.3609 20.1754 32.649 20.1754C33.4608 20.1848 34.5883 20.1871 35.5456 20.1848C36.036 20.1836 36.2852 19.5977 35.9451 19.2437C34.7164 17.966 32.5162 15.6762 31.256 14.367Z",
    fill: "#03A438"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9751 24.6405H26.9176C27.3963 24.6405 27.7853 24.2527 27.7853 23.774C27.7853 23.2953 27.3963 22.9062 26.9176 22.9062H22.9751C22.4964 22.9062 22.1085 23.2953 22.1085 23.774C22.1085 24.2527 22.4964 24.6405 22.9751 24.6405ZM22.9749 30.4573H29.3156C29.7943 30.4573 30.1833 30.0694 30.1833 29.5907C30.1833 29.112 29.7943 28.723 29.3156 28.723H22.9749C22.4962 28.723 22.1084 29.112 22.1084 29.5907C22.1084 30.0694 22.4962 30.4573 22.9749 30.4573Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyRefer);
export default __webpack_public_path__ + "static/media/copy-refer.7183b9c5.svg";
export { ForwardRef as ReactComponent };